import { render } from "./DetalleFacturaGeo.vue?vue&type=template&id=0963b208&scoped=true"
import script from "./DetalleFacturaGeo.vue?vue&type=script&lang=js"
export * from "./DetalleFacturaGeo.vue?vue&type=script&lang=js"

import "./DetalleFacturaGeo.vue?vue&type=style&index=0&id=0963b208&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-0963b208"

export default script